import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import IUserProfile from '../interfaces/IUserProfile';
import useAppLog from '../../../app/features/log/hooks/useAppLog';

const useUserProfile = (filterCompanyIds?: number[]) => {
	const auth = useAuthContext();
	const graphQLClient = useGraphQLClient();
	const appLog = useAppLog();

	const { data, isFetching } = useQuery<IUserProfile | null, Error>(
		['userProfile', filterCompanyIds],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query ($filterCompanyIds: [Int]) {
							userProfile(filterCompanyIds: $filterCompanyIds) {
								id
								welcomed
								login
								email
								firstName
								lastName
								mobilePhone
								defaultRounding
								defaultLanguage
								realizationStatus
								securityMethod
								contacts {
									isMoral
									firstname
									lastname
									moralName
									phone
									email
									roleTag
									pictureTag
									expertiseTag
								}
								features {
									emailNotificationEnabled
								}
								notificationTags
							}
						}
					`,
					{
						filterCompanyIds: filterCompanyIds,
					},
				)) as { userProfile: IUserProfile };

				return data.userProfile;
			} catch (e) {
				appLog.exception(e, { component: 'useUserProfile' });
				return null;
			}
		},
		{
			enabled: appLog && auth.currentCompany !== null && auth.isInvestor === true && auth.isAuthenticated,
		},
	);

	return {
		isFetching,
		investorProfile: data,
	};
};

export default useUserProfile;
